import waterIcon from '../static/images/activity_type_icons/water.png';
import airIcon from '../static/images/activity_type_icons/air.png';
import landIcon from '../static/images/activity_type_icons/land.png';
import snowIcon from '../static/images/activity_type_icons/snow.png';
import bestViewIcon from '../static/images/activity_type_icons/best_view.png';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setNewFilters } from '../redux/filtersSlice';
import { useTranslation } from 'react-i18next';
import React from 'react';

const ActivityIconSection = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleClick = (event) => {
        const { id } = event.target;
        dispatch(setNewFilters({ activityType: [id] }));
        navigate('choose-category');
    }
    return (
        <React.Fragment>
            <div className='mt-16 mb-2 w-full lg:w-[1000px]'>
                <h1 className="text-[#225424] hidden xl:block">{t('Homepage.chooseActivityTitle')}</h1>
                <h2 className="text-[#225424] hidden md:block xl:hidden">{t('Homepage.chooseActivityTitle')}</h2>
                <h3 className="text-[#225424] md:hidden">{t('Homepage.chooseActivityTitle')}</h3>
            </div>
            
            <div className="w-full lg:w-[1000px] flex gap-4 justify-start flex-nowrap overflow-x-auto py-8 hide-scrollbar">
                <div className='min-w-[144px] md:flex-1 flex flex-col items-center cursor-pointer'>
                    <img id="Acqua" alt="" src={waterIcon} className='w-full h-[144px] md:h-full' onClick={handleClick} />
                    <h3>{t('Homepage.ActivityIconSection.water')}</h3>
                </div>
                <div className='min-w-[144px] md:flex-1 flex flex-col items-center cursor-pointer'>
                    <img id="Aria" alt="" src={airIcon} className='w-full h-[144px] md:h-full' onClick={handleClick} />
                    <h3>{t('Homepage.ActivityIconSection.air')}</h3>
                </div>

                <div className='min-w-[144px] md:flex-1 flex flex-col items-center cursor-pointer'>
                    <img id="Terra" alt="" src={landIcon} className='w-full h-[144px] md:h-full' onClick={handleClick} />
                    <h3>{t('Homepage.ActivityIconSection.land')}</h3>
                </div>

                <div className='min-w-[144px] md:flex-1 flex flex-col items-center cursor-pointer'>
                    <img id="Neve" alt="" src={snowIcon} className='w-full h-[144px] md:h-full' onClick={handleClick} />
                    <h3>{t('Homepage.ActivityIconSection.snow')}</h3>
                </div>

                <div className='min-w-[144px] md:flex-1 flex flex-col items-center cursor-pointer'>
                    <img id="Best Views" alt="" src={bestViewIcon} className='w-full h-[144px] md:h-full' onClick={handleClick} />
                    <h3>{t('Homepage.ActivityIconSection.bestViews')}</h3>
                </div>

            </div>
        </React.Fragment>

    )
}

export default ActivityIconSection;